import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Cooler65 from "../image/SAC9.jpg";
import AC2ton from "../image/AC011.jpg";
import Ac111 from "../image/AC01.jpg";
import Cooler1 from "../image/SAC1.jpg";

// Sample Product Data (Note: Adjust IDs if needed)
const products = [
  {
    id: 7,
    name: "G-Plus glacier ",
    image: Cooler1,
    capacity: 55,
    trending: true,
  },
  {
    id: 7,
    name: "G-Plus bloom ",
    image: Ac111,
    capacity: 3,
    trending: true,
  },
  {
    id: 7,
    name: "G-Plus Premium",
    image: AC2ton,
    capacity: 40,
    trending: false,
  },
  {
    id: 7,
    name: "G-Plus Premium",
    image: Cooler65,
    capacity: 65,
    trending: false,
  },
];

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/luxury-appliances/${product.id}`}
      className="min-w-[280px] p-5 w-[280px] h-[400px] bg-white m-2 flex flex-col shadow-xl rounded-lg cursor-pointer items-center justify-between relative snap-start"
    >
      {/* Trending Label */}
      {product.trending && (
        <div className="absolute top-3 left-3 bg-yellow-400 text-black text-xs px-2 py-1 rounded-md font-bold">
          TRENDING
        </div>
      )}

      {/* Capacity Badge */}
      <div className="absolute top-3 right-3 bg-blue text-white text-xs px-3 py-1 rounded-md font-bold">
        {product.capacity} Litres
      </div>

      {/* Product Title */}
      <h1 className="font-black mt-5 text-xl underline text-[#800000] uppercase text-center">
        {product.name}
      </h1>

      {/* Product Image */}
      <img
        className="w-[250px] h-[200px] object-contain rounded-lg"
        src={product.image}
        alt={product.name}
      />

      {/* Explore Button */}
      <div className="flex items-center w-full">
        <button className="bg-white text-black px-4 py-2 border border-black rounded-md flex-1 font-semibold hover:bg-[#800000] hover:text-white">
          Explore
        </button>
      </div>
    </Link>
  );
};

const Aircooler = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="px-4 py-6 bg-gray font-roboto relative">
      <h1 className="text-2xl font-bold text-center mb-4 uppercase tracking-wide">
        Air Coolers
      </h1>

      {/* Arrow Buttons for Mobile (hidden on larger screens) */}
      <div className="sm:hidden flex justify-between items-center mb-3 px-2">
        <button
          onClick={() => scroll("left")}
         className="bg-[#dffff] p-2 rounded-full text-teal-800 shadow-md"
        >
          <FaChevronLeft />
        </button>
        <button
          onClick={() => scroll("right")}
          className="bg-[#dffff] p-2 rounded-full text-teal-800 shadow-md"
        >
          <FaChevronRight />
        </button>
      </div>

      {/* Cards Container: Horizontal scroll on mobile; flex-wrap on larger screens */}
      <div
        ref={scrollRef}
        className="mt-4 sm:grid sm:grid-cols-2 md:grid-cols-4 gap-6 overflow-x-auto sm:overflow-visible flex sm:flex-none space-x-4 sm:space-x-0 scroll-smooth snap-x snap-mandatory pb-4"
      >
        {products.map((product, index) => (
          <ProductCard key={index} product={product} />
        ))}
      </div>
    </div>
  );
};

export default Aircooler;
